module.exports = __webpack_public_path__ + "9e311c0d1b498648aace66bf5c453dca.gif";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/sponsors.gif
// module id = 980
// module chunks = 2